import { useTranslation } from 'react-i18next';
import { FeatureServiceKey } from '../../../../store/features/healthDashboard/healthDashboardSlice';
import FeatureTile, {
    FeatureTileComponent,
} from '../../FeatureTile/FeatureTile';
import { useSelector } from '../../../../store/hooks';
import { useFeatureStatus, useIssueFeatureItems } from '../../healthUtils';
import { PeopleRegular } from '@fluentui/react-icons';

const relatedServices: readonly FeatureServiceKey[] = [
    'crewRoster',
    'functionApp',
    'grpcServer',
] as const;

const CrewTile: FeatureTileComponent = ({ className }) => {
    const { t } = useTranslation();

    const { healthInfo } = useSelector((x) => x.healthDashboard);

    const info = healthInfo?.crewAssignment;

    const status = useFeatureStatus(
        info && info.errorCount > 0,
        info?.lastSuccessOnUtc,
        info?.lastErrorOnUtc
    );

    const items = useIssueFeatureItems(info?.errorCount, status);

    return (
        <FeatureTile
            title={t('Health_Crew_Title')}
            icon={<PeopleRegular />}
            status={status}
            items={items}
            relatedServices={relatedServices}
            className={className}
        />
    );
};

export default CrewTile;
